import React from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import { X, Play, RotateCcw, BookOpen } from 'lucide-react';

// Botón "?" flotante. Disponible siempre que el tour no esté corriendo ni la
// bienvenida abierta: antes solo salía con el tour completado, así que con el
// tour apagado o a medias no había forma de iniciarlo. El menú depende del
// estado: sin iniciar → Iniciar; a medias → Retomar / Empezar de nuevo;
// completado → Ver de nuevo. La guía rápida siempre está.
export default function HelpButton() {
  const {
    showHelpMenu, setShowHelpMenu, setShowQuickGuide, setShowWelcome,
    resumeTour, resetAndRestart, restartTour, tourActive, showWelcome, tourStatus, resumeIndex, steps,
  } = useOnboarding();

  if (tourActive || showWelcome) return null;

  const total = steps?.length || 0;
  const items = [];
  if (tourStatus === 'never') {
    items.push({ id: 'help-start', icon: Play, label: 'Iniciar el recorrido',
      onClick: () => { setShowHelpMenu(false); setShowWelcome(true); } });
  } else if (tourStatus === 'in_progress') {
    items.push({ id: 'help-resume', icon: Play, label: `Retomar en el paso ${resumeIndex + 1} de ${total}`, onClick: resumeTour });
    items.push({ id: 'help-restart', icon: RotateCcw, label: 'Empezar desde el inicio', onClick: resetAndRestart });
  } else {
    items.push({ id: 'help-restart', icon: RotateCcw, label: 'Ver el recorrido de nuevo', onClick: restartTour });
  }
  items.push({ id: 'help-quick-guide', icon: BookOpen, label: 'Ver guía rápida',
    onClick: () => { setShowHelpMenu(false); setShowQuickGuide(true); } });

  return (
    <>
      <button
        onClick={() => setShowHelpMenu(true)}
        className="fixed bottom-6 right-6 z-[1000] w-12 h-12 bg-soem-primary text-white rounded-full shadow-lg hover:bg-soem-primary-hover transition-all hover:scale-105 flex items-center justify-center group"
        data-testid="help-button"
        aria-label="Recorrido de bienvenida y guía rápida"
        title="Recorrido de bienvenida"
      >
        <span className="font-black text-xl">?</span>
        <span className="absolute right-full mr-3 bg-soem-navy text-white text-xs px-2.5 py-1 rounded-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Recorrido y guía rápida
        </span>
      </button>

      {showHelpMenu && (
        <div className="fixed inset-0 z-[9998] flex items-end justify-end p-6 pb-24">
          <div className="fixed inset-0 bg-black/20" onClick={() => setShowHelpMenu(false)} />
          <div className="relative bg-white rounded-sm shadow-2xl w-72 animate-fade-in border border-slate-200" role="menu" data-testid="help-menu">
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100 bg-soem-navy rounded-t-sm">
              <p className="text-white font-semibold text-sm">¿Qué deseas hacer?</p>
              <button aria-label="Cerrar menú de ayuda" onClick={() => setShowHelpMenu(false)}><X size={16} className="text-slate-400 hover:text-white" /></button>
            </div>
            <div className="p-2 space-y-1">
              {items.map(({ id, icon: Icon, label, onClick }) => (
                <button key={id} onClick={onClick} data-testid={id} role="menuitem"
                  className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-blue-50 rounded-sm text-sm text-left transition-colors">
                  <Icon size={15} className="text-soem-primary flex-shrink-0" />
                  <span className="text-soem-navy">{label}</span>
                </button>
              ))}
              <div className="border-t border-slate-100 pt-1">
                <button onClick={() => setShowHelpMenu(false)}
                  className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-slate-50 rounded-sm text-sm text-left text-slate-400 transition-colors">
                  <X size={15} className="flex-shrink-0" /> Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
